import { IsBoolean, IsDefined, IsInt, IsOptional, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '../../constants';

export class BillingProductReplaceDto {
  @IsDefined()
  @IsInt()
  id: number;

  @IsDefined()
  @IsString()
  @Length(0, 150)
  name: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  displayName: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsDefined()
  @IsBoolean()
  isIntegration: boolean;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  description?: string

  @IsOptional()
  @IsString()
  @Length(0, 255)
  imageUrl?: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.url)
  learnMoreUrl?: string;

  @IsDefined()
  @IsInt()
  channelTypeId: number;
}